// Single home for vue-select + its CSS so consuming pages import one path.
import VueSelect from "vue-select"
import "vue-select/dist/vue-select.css"

export default VueSelect
